window.addEventListener('load', () => {

    const publicationCardPanels = document.querySelectorAll('.publication-card-panel');

    for (const publicationCardPanel of publicationCardPanels) {
        let cardLimit = publicationCardPanel.querySelector('[data-card-limit]').dataset.cardLimit;

        if (cardLimit) {
            cardLimit = parseInt(cardLimit);
            const publicationCards = publicationCardPanel.querySelectorAll('[data-publication]');
            const showMoreBtn = publicationCardPanel.querySelector('[data-button-show="more"]');
            const showLessBtn = publicationCardPanel.querySelector('[data-button-show="less"]');
            const defaultVisibleCount = cardLimit;
            let currentlyVisibleCount = defaultVisibleCount;

            function updateVisibility() {
                publicationCards.forEach((publicationCard, index) => {
                    if (index < currentlyVisibleCount) {
                        publicationCard.classList.remove('hidden');
                    } else {
                        publicationCard.classList.add('hidden');
                    }
                });

                if (currentlyVisibleCount < publicationCards.length) {
                    showMoreBtn.classList.remove('hidden');
                } else {
                    showMoreBtn.classList.add('hidden');
                }

                if (currentlyVisibleCount > defaultVisibleCount) {
                    showLessBtn.classList.remove('hidden');
                } else {
                    showLessBtn.classList.add('hidden');
                }
            }

            function showMore() {
                currentlyVisibleCount = Math.min(currentlyVisibleCount + defaultVisibleCount, publicationCards.length);
                updateVisibility();
            }

            function showLess() {
                currentlyVisibleCount = defaultVisibleCount;
                updateVisibility();
                if (window.innerWidth < 768) {
                    publicationCardPanel.scrollIntoView({ behavior: 'smooth' });
                }
            }

            showMoreBtn.addEventListener('click', showMore);
            showLessBtn.addEventListener('click', showLess);

            updateVisibility();
        }
    }

});